<template>
  <div class="content-wrapper">
    <spinner size="medium" line-fg-color="#44c7f0" class="spinner" />
  </div>
</template>

<script>
import Referrals from '@/api/referrals'
import Spinner from 'vue-simple-spinner'
export default {
  components: { Spinner },
  computed: {
    token () {
      return this.$route.params.token
    }
  },
  async mounted () {
    const token = this.token
    const email = this.$route.query.email
    try {
      await Referrals.consumeEmailReferral({ token, email })
      this.$router.push(`/signup`)
    } catch (error) {
      this.$router.push(`/signup`)
    }
  }

}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/referrals/email.vue